'use client';

import type { ReactNode } from 'react';
import { HStack } from '@terra/ui-styled-system';
import {
  isPlainRecord,
  type TerminalAutoApproval,
} from '@terra/shared-dto-chat-types';
import { HitlElevatedBadge } from '../../HITL/components/HitlElevatedBadge';
import {
  AutoApprovalBadge,
  readAutoApproval,
} from '../shared/auto-approval-badge';

export function readTerminalAutoApproval(
  input: unknown,
): TerminalAutoApproval | undefined {
  return isPlainRecord(input)
    ? readAutoApproval(input.autoApproval)
    : undefined;
}

export function readTerminalElevated(input: unknown): boolean {
  return isPlainRecord(input) && input.elevated === true;
}

export function withTerminalApprovalBadges({
  input,
  actions,
}: {
  input: unknown;
  actions: ReactNode;
}): ReactNode {
  const autoApproval = readTerminalAutoApproval(input);

  if (!autoApproval) {
    return actions;
  }

  return (
    <HStack gap={1} alignItems="center">
      {readTerminalElevated(input) ? <HitlElevatedBadge /> : null}
      <AutoApprovalBadge autoApproval={autoApproval} subject="command" />
      {actions}
    </HStack>
  );
}
